import 'css-chunksrc/client/scenes/project/resources/section/styles.scss';export default {
  "section": "_section_1vg67_1",
  "header": "_header_1vg67_5",
  "title": "_title_1vg67_14",
  "iconBox": "_iconBox_1vg67_20",
  "toggled": "_toggled_1vg67_26",
  "icon": "_icon_1vg67_20"
};